import { withInstall } from '../../../utils/with-install'
import GeoJSON from './GeoJSON.vue'

export const ElAmapGeojson = withInstall(GeoJSON)
export default ElAmapGeojson
